var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-group-container flex"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"match-group-item bg1 padding-12 text-center",on:{"click":function($event){return _vm.goGroupList(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }